import { useEffect } from 'react';

import { useEntitlementsQuery } from 'data/generated/graphql';
import { reportError } from 'utils/errorBoundary';

export type EntitlementItem = {
  label: string;
  key: string;
};

const useEntitlementsData = () => {
  const queryResult = useEntitlementsQuery(undefined, {
    staleTime: 60000
  });
  const { data } = queryResult;

  useEffect(() => {
    if (queryResult.error) {
      reportError('Failed to fetch entitlements', queryResult.error as Error);
    }
  }, [queryResult.error]);

  const entitlements: EntitlementItem[] = data?.entitlements ?? [];

  return {
    entitlements,
    isLoading: queryResult.isLoading,
    error: queryResult.error
  };
};

export default useEntitlementsData;
